<template>
	<div>
	</div>
</template>


<script>
import HTTP from "../http";
export default {

	created() {
		HTTP().post("/auth/logout").then((resp) => { console.log(resp.data) })
		localStorage.removeItem('access_token');
		localStorage.removeItem('user');
		this.$router.push({ name: 'Login' })
	}
}

</script>